import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import { unix2date6 } from 'src/helper/time'
import 'swiper/swiper-bundle.min.css'
import http from 'src/helper/http'
import ReminderBtn from 'src/component/RuleButton'
import Message from 'src/component/Message'
import fileType from 'src/helper/fileType'
import {  chooseImage, uploadFile } from 'src/helper/webviewFun'
import vs from '../../../helper/vconsole'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    lang: langM.ar,
    language: null,
    userInfo: {},
    uploadpic:[],
    ipormac: null,
    timemyselect: null,
    myUserInfo:{},
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    if (uid == 793248) {
      new vs()
    }
    this.setState({
      uid: uid,
      fidUid:this.props.location.query.finduid*1,
      onSetNbs:this.props.location.query.onSetNbs*1
    })

    if (this.state.language == 'tr') {
      setDocumentTitle('Yönetici Kontrol Paneli')
    } else if (this.state.language == 'en') {
      setDocumentTitle('Admin control panel')
    } else if (this.state.language == 'ar') {
      setDocumentTitle('لوحة تحكم المشرف ')
    }
    await this.getUserInfo(this.props.location.query.finduid)
    await this.getPerworUserInfo(uid)
    console.log(this.state)
  }


  showGoldModle = (open, close) => {
    let { lang } = this.state
    return (
      <div
        className="gold-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.removeText}</div>
        <div className="gold-modle-body">


        </div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.no}
          </div>
          <div
            className="modle-confirm"
            onClick={() => this.banTimeandType()}
          >
            {lang.yes}
          </div>
        </div>
      </div>
    )
  }
  showModle = (open, close) => {
    let { lang } = this.state
    return (
      <div
        className="gold-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.banText}</div>
        <div className="gold-modle-body">
        </div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.no}
          </div>
          <div
            className="modle-confirm"
            onClick={() => this.resetRoomInfo()}
          >
            {lang.yes}
          </div>
        </div>
      </div>
    )
  }
  // 初始化/接口请求初始化
  resetRoomInfo = async()=>{
    let { setValue,  lang, fidUid , uploadpic, uid  } = this.state
    if (uid == fidUid)  return  this.refs.msg.show(lang.nohad)
    let res = await http.post('/web/user/reset',{uid:fidUid,reason:setValue,pic:uploadpic[0]})
    if (res.code == 0) {
      this.refs.msg.show(lang.successful)
    }else if (res.code == 9999 ) {
      this.refs.msg.show(lang.nohad)
    } 
    
  }
  getUserInfo = async (uid) => {
    let res = await http.post('/web/user/info', { uidDuid: uid + '' })
    if (res.code == 0) {
      this.setState({ userInfo: res.res })
    }
  }
  getPerworUserInfo = async (uid) => {
    let res = await http.post('/web/user/info', { uidDuid: uid + '' })
    if (res.code == 0) {
      this.setState({ myUserInfo: res.res })
    }
  }
  selectMytype = (e) => {
    this.setState({ ipormac: e.target.value * 1 })
  }
  selectTime = (e) => {
    this.setState({ timemyselect: e.target.value * 1 })
  }
 
  async get132(aa) {
    console.log("选择图片")

    let map = {
      count: 1, //可以选择的最多数量
      sizeType: 'compressed', //大小压缩 original/compressed
      mp4Enabled: false //是否可以选择mp4，true等于可以同时选mp4和图片
    }
    console.log('选择图片提交的参数', map)
    chooseImage(map, (d) => { //只能把回调放在这里，因为是异步回调，无法改成async await
      console.log('选择图片回调', d)
      this.setState({
        pic: d || []
      })
     this.get16(d)
    })
   
    return
  }
   get16=async(url)=> {
    console.log("pic的图片数量" + url.length)
    if (url.length > 0) {
      let req = []
      for (let i = 0; i < url.length; i++) {
        req.push({
          filePath: url[i].path,
          fileType: fileType.get(url[i].path)
        })
      }
      // console.log("选择的图片数量" + req.length)
      console.log("调用dsBridge上传前", req)

      console.log('上传之前的图片地址')
        for (let i = 0; i < req.length; i++) {
          console.log(req[i].filePath+" 文件类型 " + req[i].fileType)
        }

      uploadFile(req, (d) => {
        console.log('上传之后的图片地址',d)
        this.setState({
          uploadpic: d || []
        })
        // for (let i = 0; i < d.length; i++) {
        //   console.log(d[i].filePath+" 对应上传网址是 " + d[i].url)
        // }

        // uploadpic

      })
    } else {
      console.log("没有选择图片")
    }
  }

  clearImg = () => {
    this.setState({
      uploadpic:[],
    })
  }
  banTimeandType = async () => {
    let { ipormac, timemyselect, setValue, uid, lang, fidUid, uploadpic,  } = this.state
    debugger
    if (!ipormac) return this.refs.msg.show(lang.noselectTypeText)
    if (timemyselect == null) return this.refs.msg.show(lang.noselectTimeText)
    
    let res = await http.post('/web/user/forbid', { remark: setValue,ftype: ipormac, forbidts: timemyselect,uid:fidUid,pic:uploadpic[0]})
    if (res.code == 0 ) {
      this.refs.msg.show(lang.successful)
    }else if (res.code == 9999 ) {
      this.refs.msg.show(lang.nohad)
    }
   
  }
  setRamekValue = (e)=>{
    this.setState({setValue: e.target.value})
  }
  render() {
    let { lang, userInfo ,  myUserInfo} = this.state
    return (
      <div className="bane-reset">
        <div className="user-card">
          <div className="set-user-info">
            <div className="avatar-root">
              <img className="avatar-img" src={userInfo.avatarurl}></img>
            </div>
            <div className="user-info">
              <div className="user-info-top">
                <div className="top-text">{userInfo.nickname}</div>
              </div>
              <div className="user-info-top">
                <div className="top-text">{userInfo.bio}</div>
              </div>
              <div className="user-info-buttom">ID: {userInfo.uid}</div>
            </div>
          </div>
        </div>

          <div className="text-title">{lang.banInOne}</div>
        <div className="select-ban">
          <div className="type-select">
            <div className="text-type">Type</div>
            <fieldset onChange={(e) => this.selectMytype(e)} className="one">
              {myUserInfo && (myUserInfo.forbidPower==1 || myUserInfo.forbidPower==4) && <div>
                <input type="radio" id="huey" name="drone" value="2" />
                <label for="huey" htmlFor="radio">
                  Mac
                </label>
              </div>}
              {false && myUserInfo && (myUserInfo.forbidPower==1 || myUserInfo.forbidPower==3) && <div>
                <input type="radio" id="dewey" name="drone" value="1" />
                <label for="dewey" htmlFor="radio">
                  IP
                </label>
              </div>}
              { myUserInfo && (myUserInfo.forbidPower==1 || myUserInfo.forbidPower==2) && <div>
                <input type="radio" id="louie" name="drone" value="3" />
                <label for="louie" htmlFor="radio">
                  User ID
                </label>
              </div>}
            </fieldset>
          </div>
          <div className="time-select">
            <div className="text-type">Time</div>
            <fieldset onChange={(e) => this.selectTime(e)} className="two">
              <div>
                <input type="radio" id="hour" name="two" value="1" />
                <label for="hour" htmlFor="radio">
                  1 hour
                </label>
              </div>
              <div>
                <input type="radio" id="hours" name="two" value="2" />
                <label for="hours" htmlFor="radio">
                  6 hour
                </label>
              </div>
              <div>
                <input type="radio" id="day" name="two" value="3" />
                <label for="day" htmlFor="radio">
                  1 day
                </label>
              </div>
              <div>
                <input type="radio" id="days" name="two" value="4" />
                <label for="days" htmlFor="radio">
                  3 day
                </label>
              </div>
              <div>
                <input type="radio" id="log" name="two" value="5" />
                <label for="log" htmlFor="radio">
                  7 day
                </label>
              </div>
              <div>
                <input type="radio" id="log" name="two" value="6" />
                <label for="log" htmlFor="radio">
                  1 month
                </label>
              </div>
              <div>
                <input type="radio" id="log" name="two" value="8" />
                <label for="log" htmlFor="radio">
                  1 year
                </label>
              </div>
            </fieldset>
          </div>
        </div>
        <div className="text-title">{lang.reason}</div>
        <div className="reason-root">
          <div className="input-root">
            <textarea
              className="reason-root-input"
              name="story"
              rows="3"
              cols="34"
              placeholder={lang.poaloder}
              maxLength={100}
              onChange={e=>this.setRamekValue(e)}
            ></textarea>
          </div>
          <div className="upload-root">
             {this.state.uploadpic.length>0 && <img src={this.state.uploadpic[0]} className='upload'></img>}
             {this.state.uploadpic.length>0 && <img src='/img/app/admin-control-panel/delect_icon.png' className='del-icon' onClick={this.clearImg}></img>}
             {!this.state.uploadpic.length>0 && <div className='text-title'>upload</div>}
             {!this.state.uploadpic.length>0 && <div
              id="upload"
              className="upload"
              onClick={()=>this.get132()}
            />}
          
            
          </div>
        </div>
        <ReminderBtn
          lang={this.state.lang}
          slotButtonComp={() => {
            return <div className="ban-reset">{lang.banorSet}</div>
          }}
          slotContentComp={this.showGoldModle}
        />


        <Message ref="msg"  />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/admin-control/bane-reset/index.js